module.exports = __webpack_public_path__ + "img/experience_enhancement_2.30094525.png";